import axios from 'axios';
import prepareQueryString from '@/utils/prepareQueryString';
import { subject as an } from '@casl/ability';
import { adminPath } from '@/api/helpers/apiPath';

export default {
  getClientFeedbacks(params) {
    return axios.get(adminPath('/client_feedbacks?') + prepareQueryString(params)).then((response) => {
      return {
        clientFeedbacks: response.data.map((clientFeedback) => an('ClientFeedback', clientFeedback)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  get(id) {
    return axios.get(adminPath(`/client_feedbacks/${id}`)).then((response) => an('ClientFeedback', response.data));
  },
  update(id, data) {
    return axios
      .patch(adminPath(`/client_feedbacks/${id}`), {
        ...data,
      })
      .then((response) => an('ClientFeedback', response.data));
  },
  create(data) {
    return axios
      .post(adminPath('/client_feedbacks'), {
        ...data,
      })
      .then((response) => an('ClientFeedback', response.data));
  },
  getSpreadsheet(params) {
    return axios.get(adminPath('/client_feedbacks.csv?') + prepareQueryString(params), { responseType: 'blob' });
  },
  getPDF(params) {
    return axios.get(adminPath(`/client_feedbacks/${params.id}.pdf`), { responseType: 'blob' });
  },
};
